import axios from 'axios';
import { Message } from 'element-ui';
import app from '../main';
import authen from '../utils/authen';
import router from '@/router';

axios.defaults.baseURL = process.env.BASE_URI;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';

var temp = 0;

axios.interceptors.request.use(
  config => {
    authen.checkIsAuthenticated(valid => {
      if (valid) {
        let token = authen.getToken();
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        let role = authen.get('qlmn_role');
        router.push({
          name: role === 'admin' ? 'admin-login' : 'user-login'
        });
      }
    });
    // config progressbar start
    temp === 0 && app.$Progress.start();
    temp++;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    // config progressbar finish
    temp--;
    temp === 0 && app.$Progress.finish();

    // Nancy/Newtonsoft có thể ghi NaN/Infinity (JSON không hợp lệ).
    // Axios khi parse fail sẽ trả raw string → UI hiện cả blob như lỗi.
    return parseApiPayload(response.data);
  },
  error => {
    temp--;
    temp === 0 && app.$Progress.fail();
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

function parseApiPayload (data) {
  if (typeof data !== 'string') return data;
  const trimmed = data.trim();
  if (!trimmed) return data;
  const first = trimmed[0];
  if (first !== '{' && first !== '[' && first !== '"') return data;
  try {
    return JSON.parse(
      trimmed
        .replace(/:\s*NaN\b/g, ':null')
        .replace(/:\s*-Infinity\b/g, ':null')
        .replace(/:\s*Infinity\b/g, ':null')
    );
  } catch (e) {
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/utils/axios.js